import { useRouter } from "../../composables/useRouter";
/**
 * @description 페이지 이동 처리
 * router로 이동처리 후 => 실패 시 window.location.href로 이동 처리
 *
 * @param {string} endpoint - 이동할 경로
 */
export function movePage(endpoint) {
    try {
        const router = useRouter();
        router.push(endpoint);
    }
    catch (e) {
        if (typeof window !== "undefined") {
            window.location.href = endpoint;
            return;
        }
        throw new Error("페이지 이동에 실패했습니다.");
    }
}
